import React from "react";

const HoldingsTable = ({ data, columns, onRowClick }) => {
  // Add sample data with gains and losses if none exists
  const enhancedData = data.map(row => ({
    ...row,
    gainLoss: row.gainLoss || (Math.random() > 0.5 ? 1 : -1) * Math.floor(Math.random() * 10000),
  }));

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.accessor}
                className="px-2 py-1 text-left text-[10px] md:text-xs font-medium text-gray-500 dark:text-white uppercase tracking-wider"
              >
                {col.Header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
          {enhancedData.map((row, idx) => (
            <tr
              key={row.id || idx}
              className="group transition-colors duration-150"
              onClick={() => onRowClick && onRowClick(row)}
              data-spotlight-target={row.symbol === "AAPL" ? "holding-AAPL-row" : undefined}
            >
              {columns.map((col) => {
                const isGainLoss = col.accessor === 'gainLoss';
                const value = isGainLoss ? row.gainLoss : (col.Cell ? col.Cell(row) : row[col.accessor]);
                const gainLossClass = isGainLoss 
                  ? (row.gainLoss >= 0 
                    ? 'text-green-600 dark:text-green-400' 
                    : 'text-red-600 dark:text-red-400')
                  : '';
                
                return (
                  <td
                    key={col.accessor}
                    className={`px-2 py-1 whitespace-nowrap text-[10px] md:text-sm text-gray-900 dark:text-white group-hover:bg-gray-50 dark:group-hover:bg-gray-700 ${gainLossClass}`}
                  >
                    {isGainLoss 
                      ? `$${Math.abs(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` 
                      : value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HoldingsTable;
